import getNavStructureDefault from './getNavStructureDefault'
import getNavStructureDropdown from './getNavStructureDropdown'
import getNavStructureMobile from './getNavStructureMobile'
import getNavStructureMobileNew from './getNavStructureMobileNew'


const getNavFromStructure = ({ root, structure, isDropdown, isMobile, isMobileNew, collections }) => {

  if (!Array.isArray(structure)) {
    return []
  }

  if (isMobileNew) {
    return getNavStructureMobileNew({ root, structure, collections })
  }

  if (isMobile) {
    return getNavStructureMobile({ root, structure })
  }

  if (isDropdown) {
    return getNavStructureDropdown({ root, structure })
  }

  return getNavStructureDefault({ root, structure })
}


export default getNavFromStructure
